import {Backdrop as MuiBackdrop, CircularProgress} from "@material-ui/core";
import React, {FC} from "react";
import styled from "styled-components/macro";
import {useTranslation} from "react-i18next";

const CancelLoading = styled.button`
    text-transform: uppercase;
    background: #085b93;
    border-radius: 50px;
    padding: 9px 20px;
    margin-top: 21px;
`

const LoadingWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`

const Backdrop = styled(MuiBackdrop)`
  color: #fff; 
  z-index: 99999999;
`

type PropsType = {
  open: boolean,
  cancelButton?: boolean,
  onClick?: () => void,
}

const Loading: FC<PropsType> = ({open, cancelButton, onClick}) => {
  const { t } = useTranslation()
  return (
    <Backdrop open={open}>
      <LoadingWrapper>
        <CircularProgress size={90}/>
        {cancelButton ? (
          <CancelLoading onClick={onClick}>{t('imagesPage_Cancel')}</CancelLoading>
        ) : null}
      </LoadingWrapper>
    </Backdrop>
  )
}

export default Loading